'use client';
import { track } from '../../../lib/util/tracking';

/**
 * Represents a resource link.
 * @param url - The URL of the resource.
 * @param concept - The concept associated with the resource.
 * @param typeName - The type name of the resource.
 * @param title - The title of the resource.
 * @param children - The children of the resource link.
 */
export default function ResourceLink({
  url,
  concept,
  typeName,
  title,
  children,
}: {
  url: string;
  concept: string;
  typeName: string;
  title: string;
  children: React.ReactNode;
}) {
  return (
    <a
      className="no-underline"
      href={url}
      target="_blank"
      onClick={() => {
        track(
          'concept_card_interaction',
          {
            feature: 'memory_anchors',
            interaction: 'click',
            concept: concept,
            type: typeName,
            url,
          },
          ['keen', 'pendo'],
        );
      }}
      data-testid={`memory-anchor-${title}`}
    >
      {children}
    </a>
  );
}
